import get from 'lodash/get'
import has from 'lodash/has'
import assign from 'lodash/assign'

export default contactModalCtrl

/** @ngInject */
function contactModalCtrl($scope, $uibModalInstance, contractSelected, DeviceChecker, RecaptchaKey, $location, MailAdresses,
                          Contact, userInfo, ContactTelephone, PermPermissionStore, ContactSubjects, gaEventsService, FileUploader, ErrorCatcher) {
    $scope.gaEventsService = gaEventsService
    $scope.urgentPhone = get(contractSelected, 'prm.help_phone')
    $scope.availableCategories = ContactSubjects.anonymous
    $scope.mailAdresse = MailAdresses
    $scope.contactTelephone = ContactTelephone
    $scope.displayForm = false
    $scope.captcha = { key: RecaptchaKey[$location.host()] }
    $scope.form = {
        api: {},
        isCustomerIdDefined: has(userInfo, 'customer_id'),
        isContactSending: false,
        isContactSent: false,
        error: {
            hasError: false,
            message: '',
        },
        model: {
            firstName: userInfo.givenname,
            lastName: userInfo.sn,
            email: userInfo.mail,
            selectedSubject: {},
            subject: undefined,
            type: undefined,
            body: undefined,
            captcha: undefined,
            attachmentToken: undefined,
        },
    }
    $scope.fileUploaderStatus = 'INITIAL'
    $scope.fileUploaderMessage = ''
    $scope.uploader = new FileUploader({
        url: '/anon/contact/attachment',
        method: 'POST',
        alias: 'attachment',
        autoUpload: true,
        onAfterAddingFile(item) {
            $scope.fileUploaderStatus = 'SENDING'
        },
        onSuccessItem(item, response, status, headers) {
            $scope.form.model.attachmentToken = response.token
            $scope.fileUploaderStatus = 'SUCCESS'
        },
        onErrorItem(item, response, status, headers) {
            ErrorCatcher.catchError(response)
            $scope.fileUploaderStatus = 'FAIL'
            $scope.fileUploaderMessage = response.message
        },
    })

    $scope.close = () => $uibModalInstance.dismiss()

    $scope.isMobile = DeviceChecker.isMobile

    $scope.switchToForm = () => {
        $scope.displayForm = true
    }

    $scope.sendMessage = function (form) {
        form.api.$setSubmitted()
        if (form.api.$invalid) {
            return
        }

        form.isContactSending = true
        const messageToSend = assign({}, form.model, {
            selectedSubject: undefined,
            subject: form.model.selectedSubject.subject,
            type: form.model.selectedSubject.type,
        })
        return Contact.sendMessage({}, messageToSend).$promise
        .then(() => {
            form.isContactSending = false
            form.isContactSent = true
        })
        .catch((error) => {
            form.error.hasError = true
            form.isContactSending = false
            form.isContactSent = false
            form.error.message = error.data.message
            return ErrorCatcher.catchError(error)
        })
    }

    const activate = function () {
        __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
        .then(() => {
            $scope.availableCategories = ContactSubjects.client
        }))

        return gaEventsService.newEvent('open modal - Nous Contacter')
    }

    return activate()
}

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/states/contactModal/contactModal.js